<template>
	<div>

		<div class="my-6 flex justify-between w-2/3">
			<router-link v-if="canAccess('canEditUsers')" :to="{name: 'user'}" tag="button" class="btn btn-secondary mr-2">
				Create new user
			</router-link>

			<div class="flex">
				<div class="flex items-center">
					<input id="allUsers" name="filter" value="all" v-model="filter" type="radio" class="mr-1" />
					<label for="allUsers">
						<span class="mr-8">All users</span>
					</label>

					<input id="filterActive" name="filter" value="active" v-model="filter" type="radio" class="mr-1" />
					<label for="filterActive">
						<span class="text-xs bg-blue-500 text-white p-1 rounded-md mr-8">Active</span>
					</label>

					<input id="filterArchived" name="filter" value="archived" v-model="filter" type="radio" class="mr-1" />
					<label for="filterArchived">
						<span class="text-xs bg-gray-500 text-white p-1 rounded-md mr-8">Archived</span>
					</label>

					<input id="filterDisabled" name="filter" value="disabled" v-model="filter" type="radio" class="mr-1" />
					<label for="filterDisabled">
						<span class="text-xs bg-red-500 text-white p-1 rounded-md mr-8">Disabled</span>
					</label>
				</div>
				<div class="flex">
					<Zondicon icon="search" class="w-4 mr-1 fill-current" />
					<input v-model="searchUserQuery" class="form-input w-56" type="text" placeholder="Search user" />
				</div>
			</div>
			
		</div>


		<div v-if="init" style="max-height:72vh;" class="border border-gray-300 mb-12 overflow-x-scroll w-8/12">
			<table class="table relative w-full">
				<thead>
					<tr>
						<th class="sticky z-20" style="top: -1px;">
							<div class="flex items-center">
								<div>Name</div>
								<div :class="{'text-green-600' : sort == 'name' }" class="ml-2 text-gray-500 cursor-pointer">
									<div @click="sortUsers('name')" v-if="sortDir == 'desc'">
										<Zondicon icon="arrow-thick-down" class="w-4 fill-current relative" />
									</div>
									<div @click="sortUsers('name')" v-if="sortDir == 'asc'">
										<Zondicon icon="arrow-thick-up" class="w-4 fill-current relative" />
									</div>
								</div>
							</div>
						</th>
						<th class="sticky" style="top: -1px;">
							<div class="flex items-center">
								<div>Number</div>
								<div :class="{'text-green-600' : sort == 'number' }" class="ml-2 text-gray-500 cursor-pointer">
									<div @click="sortUsers('number')" v-if="sortDir == 'desc'">
										<Zondicon icon="arrow-thick-down" class="w-4 fill-current relative" />
									</div>
									<div @click="sortUsers('number')" v-if="sortDir == 'asc'">
										<Zondicon icon="arrow-thick-up" class="w-4 fill-current relative" />
									</div>
								</div>
							</div>
						</th>
						<th class="sticky" style="top: -1px;">Role</th>
						<th class="sticky text-left" style="top: -1px;">Total vacation <br>days</th>
						<th class="sticky text-left" style="top: -1px;">Status</th>
						<th v-if="canAccess('canEditUsers')" class="sticky z-20" style="top: -1px;">Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="user in filteredUsers" :key="user.uid" :class="getRoleClass(user.role)">
						<td>
							<div class="flex items-center">
								<span>
									<Zondicon icon="user" class="w-4 mr-4 fill-current" />
								</span>
								<span>{{ user.name }}</span>
								<div class="tooltip" v-if="user.isPartTime">
									<div class="w-2 h-2 bg-blue-500 rounded-full ml-2"></div>
									<span class="tooltip-text">Part time</span>
								</div>
								<div class="tooltip" v-if="user.isExternal">
									<div class="w-2 h-2 bg-yellow-600 rounded-full ml-2"></div>
									<span class="tooltip-text">External employee</span>
								</div>
							</div>
						</td>
						<td>{{ user.number }}</td>
						<td>{{ getRoleName(user.role) }}</td>
						<td>{{ user.totalVacationsDays }}</td>
						<td>
							<span v-if="!user.archived && !user.disabled" class="text-xs bg-blue-500 text-white p-1 rounded-md mr-1">Active</span>
							<span v-if="user.archived" class="text-xs bg-gray-500 text-white p-1 rounded-md mr-1">Archived</span>
							<span v-if="user.disabled" class="text-xs bg-red-500 text-white p-1 rounded-md">Disabled</span>
						</td>
						<td v-if="canAccess('canEditUsers')">
							<div class="flex items-center">
								<router-link class="text-gray-600 cursor-pointer tooltip inline-block mr-4" :to="{name: 'user-edit', params: {uid: user.uid}}" tag="span">
									<Zondicon icon="edit-pencil" class="w-4 fill-current" />
									<span class="tooltip-text -ml-2">Edit</span>
								</router-link>
			
								<span v-if="!user.archived" class="text-gray-600 cursor-pointer tooltip inline-block mr-4" @click="showModal(user.uid, 'modalArchive')">
									<Zondicon icon="box" class="w-4 fill-current" />
									<span class="tooltip-text -ml-4">Archive</span>
								</span>
								<span v-else class="text-gray-600 cursor-pointer tooltip inline-block mr-4" @click="showModal(user.uid, 'modalUnarchive')">
									<Zondicon icon="box" class="w-4 fill-current" />
									<span class="tooltip-text -ml-4">Unarchive</span>
								</span>
								<span v-if="!user.disabled" class="text-gray-600 cursor-pointer tooltip inline-block mr-4" @click="showModal(user.uid, 'modalDisable')">
									<Zondicon icon="block" class="w-4 fill-current" />
									<span class="tooltip-text -ml-4">Disable</span>
								</span>
								<span v-else class="text-gray-600 cursor-pointer tooltip inline-block mr-4" @click="showModal(user.uid, 'modalEnable')">
									<Zondicon icon="block" class="w-4 fill-current" />
									<span class="tooltip-text -ml-4">Enable</span>
								</span>
			
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

		<SimpleModal v-if="modalArchive" @action="archiveUser(true)" @close="modalArchive = false" :btnClass="'btn-danger'">
            <template v-slot:title>Archive this user</template>
            <template v-slot:body>Are you sure you want to archive this user?</template>
            <template v-slot:button>Archive</template>
        </SimpleModal>

		<SimpleModal v-if="modalUnarchive" @action="archiveUser(false)" @close="modalUnarchive = false" :btnClass="'btn-danger'">
            <template v-slot:title>Unarchive this user</template>
            <template v-slot:body>Are you sure you want to unarchive this user?</template>
            <template v-slot:button>Unarchive</template>
        </SimpleModal>

		<SimpleModal v-if="modalDisable" @action="disableUser(true)" @close="modalDisable = false" :btnClass="'btn-danger'">
            <template v-slot:title>Disable this user</template>
            <template v-slot:body>Are you sure you want to disable this user? The user will no longer be able to login to Marktime.</template>
            <template v-slot:button>Disable</template>
        </SimpleModal>

		<SimpleModal v-if="modalEnable" @action="disableUser(false)" @close="modalEnable = false" :btnClass="'btn-danger'">
            <template v-slot:title>Enable this user</template>
            <template v-slot:body>Are you sure you want to enable this user? The user will be able to login again to Marktime.</template>
            <template v-slot:button>Enable</template>
        </SimpleModal>
		

	</div>
</template>

<script>
import { mapState } from "vuex";
import { db, auth } from "@/firebase";
import Zondicon from 'vue-zondicons'
import axios from 'axios'
import helper from '../../helpers'
import removeDiacritis from 'diacritics';

import SimpleModal from '@/components/SimpleModal.vue'

export default {
	data() {
		return {
			modalArchive: false,
			modalUnarchive: false,
			modalDisable: false,
			modalEnable: false,
			status: false,
			uid: '',
			sort:'name',
  			sortDir:'asc',
			filter: 'active',
			searchUserQuery: ''
		};
	},

	computed: {

		...mapState({
			currentUser: state => state.user.info,
			roles: state => state.roles,
			users: state => state.users,
		}),

		init() {
			if (this.users && this.roles) return true
			return false
		},

		filteredUsers() {
			var users = this.users

			users = users.filter(user => {
				if (user.role !== 'superadmin') return 1
			})

			if (this.filter == 'active') {
				users = users.filter(user => !user.archived && !user.disabled)
			}

			if (this.filter == 'archived') {
				users = users.filter(user => user.archived)
			}

			if (this.filter == 'disabled') {
				users = users.filter(user => user.disabled)
			}

			if (this.searchUserQuery.length > 0) {
				users = users.filter(user => {
					let username = user.name.toLowerCase();
					username = removeDiacritis.remove(username);
					return username.indexOf(this.searchUserQuery) > -1
				})
			}

			users = users.sort((a, b) => {

				if (this.sort === 'name') {
					if (this.sortDir === 'asc') {
						return a.name.localeCompare(b.name)
					} else return b.name.localeCompare(a.name)
				}

				if (this.sort === 'number') {
					let modifier = 1;
					if(this.sortDir === 'desc') modifier = -1;
					return (a.number * modifier) - (b.number * modifier);
				}

				return 0;

			})

			return users;
		}
	},

	components: {
		SimpleModal,
		Zondicon
	},

	methods: {

		sortUsers(s) {
			if(s === this.sort) {
				this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
			}
			this.sort = s;
		},

		canAccess(type) {
            return helper.canAccess(type, this.currentUser)
		},
		
		showModal(uid, type, status) {
			this.uid = uid
			this[type] = true
			this.status = status
		},

		getRoleName(id) {
			if (this.roles) {
				return this.roles.find(role => role.id == id).name
			}
			return id
		},

		getRoleClass(roleId) {
            var className = ''
            switch (roleId) {
                case 'nZorCHA3D3opPKdu4Arx':
                    className = 'manager'
                    break;
                case 'rPHdxrt3Uatga4u9jx5T':
                    className = 'team-leader'
                    break;
                case 'u3WQdP6NiAhPrdQsBM4N':
                    className = 'accounter'
                    break;
            }
            
            return className;

		},
		
		archiveUser(archive) {

			db
				.collection("users")
				.doc(this.uid)
				.update({
					archived: archive
				})
				.then(() => {
					this.modalArchive = false
					this.modalUnarchive = false
					this.$toasted.show(`Archived successfully!`, {
						type: 'success'
					})
				})
				.catch(error => {
					this.modalArchive = false
					this.modalUnarchive = false
					this.$toasted.show(`Error: ${error}`, {
						type: 'error'
					})
				});

		},

		disableUser(disable) {

			// disable in administration
			axios(
				{
					method: 'put',
					url: `${process.env.VUE_APP_CLOUD_FUNCTIONS_URL}/user`,
					auth: {
						username: process.env.VUE_APP_CLOUD_FUNCTIONS_USERNAME,
						password: process.env.VUE_APP_CLOUD_FUNCTIONS_PASSWORD
					},
					data: {
						uid: this.uid,
						data: {
							disabled: disable
						}
					}
				}
			)
			.then(res => {
				if (res.data.updated) {

					// disable in firestore
					db
						.collection("users")
						.doc(this.uid)
						.update({
							disabled: disable
						})
						.then(() => {
							this.modalDisable = 0;
							this.modalEnable = 0;
							this.$toasted.show('User was disabled successfully!', {
								type: 'success'
							})
						})
						.catch(error => {
							this.modalDisable = false
							this.modalEnable = false
							this.$toasted.show(`Error: ${error}`, {
								type: 'error'
							})
						});


					
				} else {
					this.modalDisable = 0;
					this.$toasted.show(res.data.message, {
						type: 'error'
					})
				}
			})
			.catch(error => {
				this.modalDisable = 0;
				this.$toasted.show(error, {
					type: 'error'
				})
			})

		}

	},

	created() {
		if (!this.users) this.$store.dispatch('getUsers')
		if (!this.roles) this.$store.dispatch('getRoles')
		this.$store.commit('SET_TITLE', 'Users Management')
	}


};
</script>